module.exports = __webpack_public_path__ + "img/Screenshot_Onlymoov.54c84fc8.svg";